<template>
    <animated-background>
        <v-dialog persistent transition="scale-transition" max-width="450" v-model="model">

            <v-card>

                <toolbar-page title="Two factor authentication"></toolbar-page>

                <div class="d-flex justify-center mt-2">
                    <v-img max-width="285" :src="cdnBaseUrl('/img/2fa.png')"/>
                </div>

                <v-card-text class="pt-5">

                    We have sent you SMS message with the authentication code. Two-Factor Authentication (2FA) is
                    an extra layer of security to ensure that you're
                    the only person who can access your account, even if someone knows your password.
                    All users are required to use two-factor authentication. If you did not receive the authentication code,
                    try login again.

                </v-card-text>

                    <v-card-text class="pt-3 d-flex justify-center">
                        <digit-input
                            v-for="input in inputs"
                            :key="input"
                            ref="digit"
                            @change="inputChanged"
                            @delete="valueDeleted"
                        ></digit-input>

                    </v-card-text>

                <v-card-actions>
                    <v-btn class="ml-2 mb-2" text @click="tryAgainClicked">Try again</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </animated-background>
</template>

<script>

import Form from "../../../components/forms/Form";
import ToolbarPage from '../../../components/UI/ToolbarPage';
import DigitInput from "../../../components/UI/DigitInput";
import AnimatedBackground from "../../../components/UI/AnimatedBackground";

export default {

    components: {
        AnimatedBackground,
        ToolbarPage,
        DigitInput
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            tokenForm: new Form({
                token: '',
            }),
            tokenFormValid: false,
            inputs: [1, 2, 3, 4, 5],
            currentFocus: 0,
            digits: [],
        }
    },

    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input',value);
            }
        }
    },

    mounted() {

        this.$nextTick(() => {
            setTimeout(() => {
                if (this.$refs.digit) {
                    this.$refs.digit[this.currentFocus].$el.children[0].focus();
                }
            }, 500);
        });
    },

    methods: {

        inputChanged(value) {

            this.digits.push(value);

            if (this.currentFocus <= 3) {
                this.$nextTick(() => {
                    this.currentFocus++;
                    this.$refs.digit[this.currentFocus].$el.children[0].focus();
                });
            }

            if (this.currentFocus === 4) {
                this.$emit('change', this.digits.join(''));
            }
        },

        valueDeleted() {

            this.digits.pop();

            if (this.currentFocus > 0) {
                this.$nextTick(() => {
                    this.currentFocus--;
                    this.$refs.digit[this.currentFocus].$el.children[0].focus();
                });
            }
        },

        tryAgainClicked() {
            this.$router.push('/spa/login');
        },

        guide() {
            // Change to the token screen
            this.$router.push('/spa/authy/token');
        }
    },

}
</script>
